module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/palm_right-7932bdd5421a855676e7462bbeb2e25b.svg";